import { EPage, PAGE_PATHNAME } from '@/constants/pages';
import { useRouter } from '@/hooks/useRouter';

export const useIsSearchPage = (): { isSearchPage: boolean } => {
  const router = useRouter();
  return { isSearchPage: router.pathname === PAGE_PATHNAME[EPage.SEARCH] };
};
